import NeverIcon from 'honeydew/icons/FoodPreferences/NeverIcon';
import RecurringIcon from 'honeydew/icons/FoodPreferences/RecurringIcon';

const RECURRING_RADIO_BUTTON_ID = 'recurring';
const DISLIKED_RADIO_BUTTON_ID = 'never';

const BUTTON_CONTENT = {
    [RECURRING_RADIO_BUTTON_ID]: {
        icon: RecurringIcon,
        inactive: 'Always add to orders',
        active: 'Added to Recurring List',
    },
    [DISLIKED_RADIO_BUTTON_ID]: {
        icon: NeverIcon,
        inactive: 'Never add to orders',
        active: 'Added to Never List',
    },
};

const PLAN_SELECTOR_BUTTON_CLASSES =
    'rounded-full border-2 cursor-pointer py-10 text-center grow border-grey-light flex justify-center';

export { RECURRING_RADIO_BUTTON_ID, DISLIKED_RADIO_BUTTON_ID, BUTTON_CONTENT, PLAN_SELECTOR_BUTTON_CLASSES };
